var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "nav",
      {
        staticClass: "pagination",
        attrs: { role: "navigation", "aria-label": "pagination" }
      },
      [
        _c("a", { staticClass: "pagination-next" }, [_vm._v(" ")]),
        _vm._v(" "),
        _c("a", { staticClass: "pagination-previous" }, [_vm._v(" ")]),
        _vm._v(" "),
        _c("ul", { staticClass: "pagination-list" }, [
          _c("li", [
            _c(
              "a",
              {
                staticClass: "pagination-item",
                attrs: { "aria-label": "Goto page 1" }
              },
              [_vm._v("1")]
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _c("span", { staticClass: "pagination-ellipsis" }, [_vm._v("…")])
          ]),
          _vm._v(" "),
          _c("li", [
            _c(
              "a",
              {
                staticClass: "pagination-item",
                attrs: { "aria-label": "Goto page 45" }
              },
              [_vm._v("45")]
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _c(
              "a",
              {
                staticClass: "pagination-item is-current",
                attrs: { "aria-label": "Page 46", "aria-current": "page" }
              },
              [_vm._v("46")]
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _c(
              "a",
              {
                staticClass: "pagination-item",
                attrs: { "aria-label": "Goto page 47" }
              },
              [_vm._v("47")]
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _c("span", { staticClass: "pagination-ellipsis" }, [_vm._v("…")])
          ]),
          _vm._v(" "),
          _c("li", [
            _c(
              "a",
              {
                staticClass: "pagination-item",
                attrs: { "aria-label": "Goto page 86" }
              },
              [_vm._v("86")]
            )
          ])
        ])
      ]
    )
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2895fa2e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2895fa2e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/shared/Pagination.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-2895fa2e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/shared/Pagination.vue
// module chunks = 0 1